module.exports = __webpack_public_path__ + "img/charade-true-icon.071cc31a.svg";